<div class="tt-guideline-review-update-footer_version">
  <mat-icon [icon]="'info'" [iconSize]="16" />
  <span>
    <span class="tt-guideline-review-update-footer_label">{{ 'Version' | transloco }}</span>
    <span class="tt-guideline-review-update-footer_bold">{{ version }}</span>
  </span>
</div>

<div class="tt-guideline-review-update-footer_center">
  <button
    data-testid="review-update-dialog-footer_button-default-view"
    emphasis="minimal"
    ttButton
    variant="secondary"
    [ttTooltip]="'DefaultView' | transloco"
    (click)="handleDefaultViewClicked()">
    <mat-icon [icon]="'restore'" [iconSize]="16" />
    <span class="tt-guideline-review-update-footer_button-label">{{ 'DefaultView' | transloco }}</span>
  </button>
  <expand-collapse-toggle />
</div>

<div class="tt-guideline-review-update-footer_actions">
  <button data-testid="review-update-dialog-footer_button-close" ttButton variant="outline" (click)="closeButtonClicked.emit()">
    <mat-icon [icon]="'chevron-left'" [iconSize]="16" />
    <span>{{ 'Back' | transloco }}</span>
  </button>

  <button data-testid="review-update-dialog-footer_button-publish" ttButton [variant]="buttonVariant" (click)="publishButtonClicked.emit()">
    <span>{{ mode === 'acceptUpdate' ? ('SingleGuidelineManager.AcceptUpdate' | transloco) : ('Publish' | transloco) }}</span>
  </button>
</div>
